import * as React from "react";
import { Button } from "@/components/ui/button";
import { Plus, ClipboardList, FolderOpen } from "lucide-react";
import { Link } from "react-router-dom";
import StudentAssignments from "./StudentAssignments";
import StudentSubmissions from "./StudentSubmissions";

const ProjectView: React.FC = () => {
  const [activeTab, setActiveTab] = React.useState<
    "assignments" | "submissions"
  >("assignments");
  return (
    <div className="min-h-screen bg-background p-4 md:p-6 lg:p-8">
      <div className="max-w-7xl mx-auto space-y-6">
        {/* Header */}
        <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
          <div>
            <h1 className="text-3xl font-bold text-gray-900 dark:text-gray-100">
              Projects & Assignments
            </h1>
            <div className="text-sm text-gray-500 dark:text-gray-400 flex items-center gap-2 mt-1">
              <span>Dashboard</span>
              <span>/</span>
              <span className="text-[#26BDB0] dark:[#127971] font-medium">
                Projects
              </span>
            </div>
          </div>

          {activeTab === "submissions" && (
            <Link to="/projects/add">
              <Button className="flex items-center gap-2 bg-[#26BDB0] hover:bg-[#49ccc1e2]">
                <Plus className="w-4 h-4" />
                Add New Submission
              </Button>
            </Link>
          )}
        </div>

        {/* Tabs */}
        <div className="flex gap-2 border-b border-gray-200 dark:border-gray-700">
          <button
            onClick={() => setActiveTab("assignments")}
            className={`flex items-center gap-2 px-6 py-3 font-medium transition-all ${activeTab === "assignments"
              ? "text-[#26BDB0] dark:text-[#127971] border-b-2 border-[#26BDB0]dark:border-[#127971]"
                : "text-gray-600 dark:text-gray-400 hover:text-gray-900 dark:hover:text-gray-200"
              }`}
          >
            <ClipboardList size={18} />
            Projects
          </button>
          <button
            onClick={() => setActiveTab("submissions")}
            className={`flex items-center gap-2 px-6 py-3 font-medium transition-all ${activeTab === "submissions"
              ? "text-[#26BDB0] dark:text-[#127971] border-b-2 border-[#26BDB0]dark:border-[#127971]"
                : "text-gray-600 dark:text-gray-400 hover:text-gray-900 dark:hover:text-gray-200"
              }`}
          >
            <FolderOpen size={18} />
            My Submissions
          </button>
        </div>

        {/* Tab Content */}
        {activeTab === "assignments" ? (
          /* Assignments Tab */
          <StudentAssignments />
        ) : (
          /* Submissions Tab */
          <StudentSubmissions />
        )}
      </div>
    </div>
  );
};

export default ProjectView;
